import { ReactComponent as Icon } from 'assets/menuWide/horizontalDivider.svg'
import React from 'react'

export default function HorizontalDivider(props: any) {
  return (
    <Icon {...props} />
  )
}